// eslint-disable-next-line
import React from 'react';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import dictionary from 'utils/dictionary';
import errorSdsSVG from 'assets/images/error_sds.svg';
import { Description, ImgContainer, Title } from '../customComponents';

type Props = {
  errorTitle?: string;
  errorMessage?: string;
  errorDetail?: string;
  fullScreen?: boolean;
  minHeight?: number | string;
  onClickRetryButton?: () => void;
};

const ErrorScreen: React.FC<Props> = ({
  errorTitle = dictionary.warningScreen_title_default,
  errorMessage = dictionary.warningScreen_message_default,
  errorDetail,
  onClickRetryButton,
  fullScreen,
  minHeight = fullScreen ? '100vh' : 250,
}) => {
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      flexDirection="column"
      textAlign="center"
      marginBottom={2}
      minHeight={minHeight}
    >
      <ImgContainer>
        <img src={errorSdsSVG} alt="Error inesperado" width="100%" />
      </ImgContainer>
      <Title>{errorTitle}</Title>
      <Description variant="body2" gutterBottom>
        {errorMessage}
      </Description>
      <Description variant="body2" gutterBottom>
        {errorDetail}
      </Description>
      {onClickRetryButton && (
        <Button
          data-testid="retry-button"
          variant="contained"
          color="primary"
          onClick={onClickRetryButton}
        >
          REINTENTAR
        </Button>
      )}
    </Box>
  );
};

export default ErrorScreen;
